import enCommon from "./en/common.json";
import frCommon from "./fr/common.json";
import enHome from "./en/home.json";
import frHome from "./fr/home.json";
import enAbout from "./en/about.json";
import frAbout from "./fr/about.json";
import enContact from "./en/contact.json";
import frContact from "./fr/contact.json";
import enPlatform from "./en/platform.json";
import frPlatform from "./fr/platform.json";
import enPartners from "./en/partners.json";
import frPartners from "./fr/partners.json";
import enSentinel from "./en/sentinel.json";
import frSentinel from "./fr/sentinel.json";
import enPathfinder from "./en/pathfinder.json";
import frPathfinder from "./fr/pathfinder.json";
import enCompass from "./en/compass.json";
import frCompass from "./fr/compass.json";
import enForesight from "./en/foresight.json";
import frForesight from "./fr/foresight.json";
import enDefense from "./en/defense.json";
import frDefense from "./fr/defense.json";
import enBanking from "./en/banking.json";
import frBanking from "./fr/banking.json";
import enTelecommunications from "./en/telecommunications.json";
import frTelecommunications from "./fr/telecommunications.json";
import enEnergy from "./en/energy.json";
import frEnergy from "./fr/energy.json";
import enHealthcare from "./en/healthcare.json";
import frHealthcare from "./fr/healthcare.json";
import enMedia from "./en/media.json";
import frMedia from "./fr/media.json";
import enPrivacy from "./en/privacy.json";
import frPrivacy from "./fr/privacy.json";
import enTerms from "./en/terms.json";
import frTerms from "./fr/terms.json";
import enCookies from "./en/cookies.json";
import frCookies from "./fr/cookies.json";
import enNotFound from "./en/notFound.json";
import frNotFound from "./fr/notFound.json";
import enSecurity from "./en/security.json";
import frSecurity from "./fr/security.json";
import enCareers from "./en/careers.json";
import frCareers from "./fr/careers.json";
import enQmp from "./en/qmp.json";
import frQmp from "./fr/qmp.json";

export const registry: Record<string, Record<string, Record<string, any>>> = {
  common: { en: enCommon, fr: frCommon },
  home: { en: enHome, fr: frHome },
  about: { en: enAbout, fr: frAbout },
  contact: { en: enContact, fr: frContact },
  platform: { en: enPlatform, fr: frPlatform },
  partners: { en: enPartners, fr: frPartners },
  sentinel: { en: enSentinel, fr: frSentinel },
  pathfinder: { en: enPathfinder, fr: frPathfinder },
  compass: { en: enCompass, fr: frCompass },
  foresight: { en: enForesight, fr: frForesight },
  defense: { en: enDefense, fr: frDefense },
  banking: { en: enBanking, fr: frBanking },
  telecommunications: { en: enTelecommunications, fr: frTelecommunications },
  energy: { en: enEnergy, fr: frEnergy },
  healthcare: { en: enHealthcare, fr: frHealthcare },
  media: { en: enMedia, fr: frMedia },
  privacy: { en: enPrivacy, fr: frPrivacy },
  terms: { en: enTerms, fr: frTerms },
  cookies: { en: enCookies, fr: frCookies },
  notFound: { en: enNotFound, fr: frNotFound },
  security: { en: enSecurity, fr: frSecurity },
  careers: { en: enCareers, fr: frCareers },
  qmp: { en: enQmp, fr: frQmp },
};
